const carouselItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20explosive%20action%20scenes%2C%20warm%20golden%20cinematic%20lighting%2C%20film%20poster%20aesthetic%2C%20dramatic%20composition%2C%20rich%20crimson%20and%20amber%20tones%2C%20epic%20scale&width=800&height=450&seq=carousel-01&orientation=landscape",
    tag: '暑期档',
    title: '2026暑期档强片盘点',
    desc: '从动作巨制到温情喜剧，暑期档十部必看佳片一网打尽，总有一部让你热血沸腾',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20director%20tribute%20visual%20with%20film%20reels%20and%20iconic%20movie%20moments%2C%20warm%20vintage%20toning%2C%20artistic%20composition%2C%20dramatic%20lighting%2C%20film%20noir%20atmosphere%2C%20golden%20accents&width=800&height=450&seq=carousel-02&orientation=landscape",
    tag: '导演特辑',
    title: '诺兰作品全回顾',
    desc: '从《记忆碎片》到《奥本海默》，重温克里斯托弗·诺兰的九部经典之作',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20visual%20with%20feminine%20aesthetic%2C%20soft%20golden%20lighting%2C%20film%20frame%20borders%2C%20artistic%20movie%20poster%20style%2C%20warm%20and%20empowering%20atmosphere%2C%20delicate%20textures&width=800&height=450&seq=carousel-03&orientation=landscape",
    tag: '女性视角',
    title: '2026必看女性导演作品',
    desc: '从细腻情感到社会议题，女性导演正在重新定义电影艺术的可能性',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgia%20visual%20with%20neon%20lights%2C%20film%20texture%2C%20vintage%20movie%20posters%2C%20warm%20retro%20aesthetic%2C%20golden%20age%20of%20HK%20films%2C%20dramatic%20noir%20lighting&width=800&height=450&seq=carousel-04&orientation=landscape",
    tag: '经典重映',
    title: '那些年我们追过的港片',
    desc: '重返香港电影黄金年代，重温周星驰、王家卫、杜琪峰的不朽经典',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">精心策划的电影专题内容，深度挖掘光影世界的无限魅力</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <div key={item.title} className="group rounded-xl overflow-hidden bg-background-100 cursor-pointer hover:bg-background-200 transition-colors">
              <div className="relative aspect-video overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs rounded-md font-medium">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}